import { useState } from 'react';

interface FAQItem {
  id: number;
  category: string;
  question: string;
  answer: string;
}

const FAQ_CATEGORIES = ['전체', '공정/일정', '비용/견적', '자재/상품', '창호', '계약/보증', '기타'];

const FAQ_DATA: FAQItem[] = [
  {
    id: 1,
    category: '공정/일정',
    question: '30평 아파트 전체 인테리어 공사 기간은 얼마나 걸리나요?',
    answer:
      '30평 기준 전체 인테리어 공사는 일반적으로 4~5주가 소요됩니다. 철거(1주) → 설비/배관(1~2주) → 목공(2~3주) → 전기/조명(3주) → 타일/바닥(3~4주) → 도장/도배(4주) → 가구/마감(4~5주) 순서로 진행됩니다. 단, 공사 범위, 자재 수급 상황, 현장 여건에 따라 일정이 달라질 수 있으며, 착공 전 정확한 일정은 현장 실측 후 안내드립니다.',
  },
  {
    id: 2,
    category: '공정/일정',
    question: '공사 중에 집에 거주할 수 있나요?',
    answer:
      '철거 및 설비 공사 기간(1~2주차)에는 분진, 소음, 냄새가 심하여 거주가 어렵습니다. 목공 이후 단계부터는 부분적으로 거주 가능하지만, 쾌적한 환경을 위해 전체 공사 기간 동안 임시 거처를 마련하시길 권장드립니다. 필요 시 임시 거처 관련 정보도 안내해 드립니다.',
  },
  {
    id: 3,
    category: '공정/일정',
    question: '공사 순서를 바꾸거나 일부 공정만 진행할 수 있나요?',
    answer:
      '네, 가능합니다. 욕실만, 주방만, 또는 도배/장판만 교체하는 부분 시공도 진행합니다. 다만 공정 간 연계성이 있어 일부 공정은 순서 변경이 어려울 수 있습니다. 예를 들어 타일 시공 전에 방수 작업이 반드시 선행되어야 합니다. 원하시는 공정 범위를 말씀해 주시면 최적의 순서로 안내드립니다.',
  },
  {
    id: 4,
    category: '비용/견적',
    question: '30평 전체 인테리어 비용은 얼마 정도 예상해야 하나요?',
    answer:
      '30평 기준 전체 인테리어(자재비 + 시공비 포함)는 일반적으로 3,500만원~5,500만원 수준입니다. 선택하는 자재 등급, 가구 브랜드, 공사 범위에 따라 크게 달라집니다. 합리적인 중급 자재 기준으로는 약 4,000만원 내외가 평균적입니다. 정확한 견적은 현장 실측 후 상세 내역서로 제공해 드립니다.',
  },
  {
    id: 5,
    category: '비용/견적',
    question: '견적서를 받은 후 계약 전에 변경이 가능한가요?',
    answer:
      '물론입니다. 견적서는 확정 계약서가 아니므로 자재 변경, 공정 추가/제외, 예산 조정 등 자유롭게 협의 가능합니다. 저희는 고객님의 예산과 요구사항에 맞춰 최적의 플랜을 제안드리며, 계약 전까지 몇 차례든 수정 견적을 제공해 드립니다.',
  },
  {
    id: 6,
    category: '비용/견적',
    question: '계약금은 얼마이며 잔금은 언제 납부하나요?',
    answer:
      '일반적으로 계약금 30%, 중도금 40%(공사 중간 단계), 잔금 30%(공사 완료 후 검수 통과 시) 구조로 진행됩니다. 공사 규모에 따라 납부 일정은 협의 조정 가능합니다. 잔금은 고객님이 최종 검수를 완료하고 만족하신 후 납부하시면 됩니다.',
  },
  {
    id: 7,
    category: '자재/상품',
    question: '자재는 직접 구매해서 가져와도 되나요?',
    answer:
      '네, 고객님이 직접 구매하신 자재를 사용하는 것도 가능합니다. 다만 자재 규격, 품질, 수량이 시공에 적합한지 사전에 확인이 필요합니다. 직접 구매 자재의 경우 하자 발생 시 자재 자체의 문제는 시공사 보증 범위에서 제외될 수 있으니 참고 부탁드립니다. 저희가 추천하는 자재 목록도 제공해 드립니다.',
  },
  {
    id: 8,
    category: '자재/상품',
    question: '친환경 자재만 사용할 수 있나요? 아이가 있어서 걱정됩니다.',
    answer:
      '네, 전 공정에 걸쳐 친환경 자재 사용이 가능합니다. 페인트는 저VOC 수성 페인트, 벽지는 친환경 인증 제품, 바닥재는 E0 등급 이상 제품을 기본으로 사용합니다. 영유아가 있는 가정의 경우 별도로 친환경 패키지를 구성해 드리며, 사용 자재의 환경 인증서도 제공해 드립니다.',
  },
  {
    id: 9,
    category: '자재/상품',
    question: '수입 자재나 고급 자재를 사용하면 비용이 얼마나 더 드나요?',
    answer:
      '수입 타일, 이탈리아산 대리석, 독일산 도어 등 고급 자재 사용 시 자재비만 국내산 대비 2~4배 수준으로 증가할 수 있습니다. 전체 공사비 기준으로는 30~50% 추가 비용이 발생하는 경우가 많습니다. 원하시는 자재 브랜드나 등급을 말씀해 주시면 해당 자재 기준으로 별도 견적을 드립니다.',
  },
  {
    id: 16,
    category: '창호',
    question: '이중창과 삼중창, 어떤 걸 선택해야 하나요?',
    answer:
      '선택 기준은 주로 위치와 목적에 따라 달라집니다.\n\n• 이중창(로이유리): 일반 주거 환경에 적합하며 단열 성능이 우수합니다. 비용 대비 효율이 높아 가장 많이 선택합니다. 개당 60~100만원 수준입니다.\n\n• 삼중창: 도로변, 지하철 인근 등 소음이 심한 환경에 강력 추천합니다. 방음 성능이 이중창 대비 30~40% 높으며, 단열 효과도 뛰어납니다. 개당 100~160만원 수준으로 비용이 더 들지만 소음 스트레스가 심한 경우 투자 가치가 충분합니다.\n\n일반 아파트 중층 이상이라면 이중창(로이유리), 저층이거나 도로변이라면 삼중창을 권장드립니다.',
  },
  {
    id: 17,
    category: '창호',
    question: '창호 교체 시 관리사무소 신고는 어떻게 하나요?',
    answer:
      '아파트 창호 교체는 외관 변경에 해당하므로 대부분의 아파트에서 관리사무소 사전 신고 및 동의가 필요합니다. 절차는 다음과 같습니다.\n\n① 관리사무소 방문 또는 서면으로 공사 신청서 제출\n② 창호 색상·규격이 단지 기준에 부합하는지 확인 (대부분 기존 색상 유지 필요)\n③ 승인 후 공사 진행\n\n저희가 신청 서류 작성을 도와드리며, 단지별 규정에 맞는 창호 제품을 선정해 드립니다. 신고 없이 시공 시 원상복구 명령이 내려질 수 있으니 반드시 사전 신고 후 진행하세요.',
  },
  {
    id: 18,
    category: '창호',
    question: '로이(Low-E) 유리가 무엇인가요? 일반 유리와 차이가 있나요?',
    answer:
      '로이(Low-E, Low Emissivity) 유리는 유리 표면에 금속 산화물 코팅을 입혀 열 복사를 차단하는 고성능 유리입니다.\n\n• 단열 성능: 일반 복층유리 대비 약 40% 향상. 겨울철 난방비 절감 효과가 큽니다.\n• 자외선 차단: UV 차단율 99% 이상으로 가구·바닥재 변색을 방지합니다.\n• 결로 방지: 실내외 온도차로 인한 결로 현상을 크게 줄여줍니다.\n• 비용: 일반 복층유리 대비 개당 15~25만원 추가 비용이 발생합니다.\n\n장기적인 에너지 절감 효과를 고려하면 로이유리 선택을 강력 추천드립니다.',
  },
  {
    id: 19,
    category: '창호',
    question: '실내 중문은 어떤 종류가 있고, 어떤 걸 선택해야 하나요?',
    answer:
      '실내 중문은 거실과 주방·현관 사이의 공간을 분리하는 문으로, 크게 세 가지 타입이 있습니다.\n\n• 슬라이딩 중문: 가장 인기 있는 타입. 공간을 많이 차지하지 않고 개폐가 편리합니다. 강화유리, 우드, 혼합 소재 선택 가능. 60~120만원 수준.\n\n• 여닫이 중문: 기밀성이 높아 냄새·소음 차단 효과가 뛰어납니다. 문이 열리는 공간이 필요합니다. 50~100만원 수준.\n\n• 포켓도어: 벽 안으로 문이 들어가는 방식으로 공간 활용도가 가장 높습니다. 시공이 복잡하고 비용이 높지만(100~180만원) 깔끔한 마감이 장점입니다.\n\n주방 냄새 차단이 목적이라면 여닫이, 공간 효율이 중요하다면 슬라이딩 또는 포켓도어를 추천드립니다.',
  },
  {
    id: 20,
    category: '창호',
    question: '창호 교체 후 결로가 생기지 않나요? 결로 방지 방법이 있나요?',
    answer:
      '시스템 창호(이중창 이상)로 교체하면 결로 발생이 크게 줄어듭니다. 결로는 실내외 온도차와 습도 차이로 발생하는데, 고성능 창호는 유리 표면 온도를 높여 결로를 방지합니다.\n\n결로 방지를 위한 추가 팁:\n• 로이유리 선택: 유리 표면 온도를 높여 결로 방지 효과 극대화\n• 창틀 단열 처리: 창틀 주변 코킹 및 단열재 시공 병행\n• 환기 습관: 하루 2~3회 10분 이상 환기로 실내 습도 조절\n• 제습기 활용: 장마철 실내 습도 50% 이하 유지 권장\n\n기존 창호에서 결로가 심했다면 삼중창 또는 로이유리 이중창으로 교체 시 확연한 개선 효과를 경험하실 수 있습니다.',
  },
  {
    id: 10,
    category: '계약/보증',
    question: '공사 후 하자 보증 기간은 얼마나 되나요?',
    answer:
      '필그린은 공사 완료 후 2년간 하자 보증을 제공합니다. 시공 불량으로 인한 균열, 들뜸, 누수 등의 하자는 무상으로 보수해 드립니다. 단, 입주 후 생활 과정에서 발생한 손상이나 자연 마모는 보증 범위에서 제외됩니다. 하자 발생 시 연락 주시면 48시간 이내 현장 확인 후 조치해 드립니다.',
  },
  {
    id: 11,
    category: '계약/보증',
    question: '공사 중 예상치 못한 추가 비용이 발생할 수 있나요?',
    answer:
      '현장 실측 후 작성된 견적서 기준으로 계약하므로 추가 비용 발생을 최소화합니다. 다만 벽체 내부 배관 상태, 기존 방수층 상태 등 철거 후에야 확인 가능한 사항으로 인해 추가 공사가 필요한 경우, 반드시 고객님께 사전 설명 및 동의를 받은 후 진행합니다. 임의로 추가 공사를 진행하지 않습니다.',
  },
  {
    id: 12,
    category: '계약/보증',
    question: '계약 후 공사 시작 전에 취소하면 어떻게 되나요?',
    answer:
      '계약 후 공사 시작 전 취소 시, 계약금의 일부가 위약금으로 발생할 수 있습니다. 구체적인 위약금 조건은 계약서에 명시되며, 계약 전 충분히 안내드립니다. 공사 시작 후 취소는 진행된 공정에 대한 비용이 정산됩니다. 계약 전 충분한 상담을 통해 결정하시길 권장드립니다.',
  },
  {
    id: 13,
    category: '기타',
    question: '아파트 인테리어 시 관리사무소 신고가 필요한가요?',
    answer:
      '네, 대부분의 아파트는 인테리어 공사 전 관리사무소에 공사 신고를 해야 합니다. 공사 기간, 작업 인원, 공사 내용 등을 신고하고 승인을 받아야 합니다. 저희가 공사 신고 서류 작성을 도와드리며, 관리사무소 규정에 맞게 공사를 진행합니다. 엘리베이터 보양, 공사 시간 준수 등도 철저히 지킵니다.',
  },
  {
    id: 14,
    category: '기타',
    question: '공사 중 이웃 세대에 피해가 생기면 어떻게 되나요?',
    answer:
      '공사 중 발생하는 소음, 분진 등은 법정 공사 시간(평일 오전 8시~오후 6시) 내에서 최소화하도록 노력합니다. 만약 공사로 인해 인접 세대에 실질적인 피해(누수, 균열 등)가 발생한 경우, 저희가 책임지고 원상복구 및 보상 처리합니다. 공사 전 인접 세대 상태를 사진으로 기록해 두는 것을 권장합니다.',
  },
  {
    id: 15,
    category: '기타',
    question: '상담부터 공사 완료까지 전체 프로세스가 어떻게 되나요?',
    answer:
      '① 온라인/전화 상담 신청 → ② 현장 실측 방문(무료) → ③ 3D 디자인 시안 제안 → ④ 견적서 검토 및 협의 → ⑤ 계약 체결 → ⑥ 자재 선정 및 발주 → ⑦ 착공(공정 순서대로 진행) → ⑧ 중간 점검 및 고객 확인 → ⑨ 최종 검수 → ⑩ 잔금 납부 및 입주. 전 과정에서 담당 PM이 배정되어 실시간으로 공사 현황을 공유해 드립니다.',
  },
];

export default function FAQSection() {
  const [activeCategory, setActiveCategory] = useState('전체');
  const [openId, setOpenId] = useState<number | null>(null);

  const filtered =
    activeCategory === '전체'
      ? FAQ_DATA
      : FAQ_DATA.filter((f) => f.category === activeCategory);

  const toggle = (id: number) => {
    setOpenId((prev) => (prev === id ? null : id));
  };

  return (
    <section className="max-w-[1200px] mx-auto px-6 md:px-12 pb-24">
      {/* Section Header */}
      <div className="text-center mb-12">
        <span
          className="inline-block text-xs font-semibold tracking-[0.3em] uppercase mb-4"
          style={{ color: '#c9a84c' }}
        >
          FAQ
        </span>
        <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">자주 묻는 질문</h2>
        <p className="text-white/50 text-base max-w-xl mx-auto leading-relaxed">
          인테리어 공사 전 궁금하신 사항들을 모았습니다.
          <br className="hidden md:block" />
          더 궁금한 점은 언제든지 상담 문의 주세요.
        </p>
      </div>

      {/* Category Filter */}
      <div className="flex flex-wrap gap-2 justify-center mb-10">
        {FAQ_CATEGORIES.map((cat) => (
          <button
            key={cat}
            onClick={() => { setActiveCategory(cat); setOpenId(null); }}
            className="px-4 py-2 rounded-full text-sm font-medium cursor-pointer transition-all duration-200 whitespace-nowrap"
            style={
              activeCategory === cat
                ? { backgroundColor: '#c9a84c', color: '#0d0d0d' }
                : { backgroundColor: '#ede8de', color: '#6b5e4e', border: '1px solid #d4c5a9' }
            }
          >
            {cat}
            {cat !== '전체' && (
              <span className="ml-1.5 text-xs" style={{ color: activeCategory === cat ? '#0d0d0d99' : '#c9a84c99' }}>
                {FAQ_DATA.filter((f) => f.category === cat).length}
              </span>
            )}
          </button>
        ))}
      </div>

      {/* FAQ List */}
      <div className="space-y-3">
        {filtered.map((item, index) => {
          const isOpen = openId === item.id;
          return (
            <div
              key={item.id}
              className="rounded-xl overflow-hidden transition-all duration-300"
              style={{ backgroundColor: '#ffffff', border: isOpen ? '1px solid #c9a84c44' : '1px solid #e8e0d0' }}
            >
              <button onClick={() => toggle(item.id)} className="w-full flex items-center gap-4 px-6 py-5 text-left cursor-pointer group">
                <span
                  className="shrink-0 w-7 h-7 flex items-center justify-center rounded-full text-xs font-bold transition-colors"
                  style={isOpen ? { backgroundColor: '#c9a84c', color: '#0d0d0d' } : { backgroundColor: '#f0ebe0', color: '#c9a84c' }}
                >
                  {String(index + 1).padStart(2, '0')}
                </span>
                <span className="shrink-0 hidden sm:inline-block text-xs font-semibold px-2.5 py-1 rounded-full" style={{ backgroundColor: '#c9a84c15', color: '#c9a84c', border: '1px solid #c9a84c30' }}>
                  {item.category}
                </span>
                <span className="flex-1 text-sm md:text-base font-medium leading-snug transition-colors" style={{ color: isOpen ? '#2a2218' : '#3a3228cc' }}>
                  {item.question}
                </span>
                <span
                  className="shrink-0 w-8 h-8 flex items-center justify-center rounded-full transition-all duration-300"
                  style={isOpen ? { backgroundColor: '#c9a84c22', color: '#c9a84c', transform: 'rotate(180deg)' } : { backgroundColor: '#f0ebe0', color: '#8a7a6a' }}
                >
                  <i className="ri-arrow-down-s-line text-lg" />
                </span>
              </button>
              <div className="overflow-hidden transition-all duration-300" style={{ maxHeight: isOpen ? '400px' : '0px' }}>
                <div className="px-6 pb-6 pt-0">
                  <div className="h-px mb-4" style={{ backgroundColor: '#c9a84c22' }} />
                  <div className="flex gap-3">
                    <div className="shrink-0 w-6 h-6 flex items-center justify-center rounded-full mt-0.5" style={{ backgroundColor: '#c9a84c22' }}>
                      <i className="ri-chat-1-line text-xs" style={{ color: '#c9a84c' }} />
                    </div>
                    <p className="text-[#6b5e4e] text-sm leading-relaxed flex-1 whitespace-pre-line">{item.answer}</p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>

      {/* CTA Banner */}
      <div
        className="mt-12 rounded-2xl p-8 flex flex-col md:flex-row items-center justify-between gap-6"
        style={{ background: 'linear-gradient(135deg, #eeece9 0%, #e8e5e0 100%)', border: '1px solid #c9a84c33' }}
      >
        <div className="flex items-center gap-5">
          <div className="w-14 h-14 rounded-full flex items-center justify-center shrink-0" style={{ backgroundColor: '#c9a84c22' }}>
            <i className="ri-question-answer-line text-2xl" style={{ color: '#c9a84c' }} />
          </div>
          <div>
            <p className="text-[#2a2218] font-bold text-lg">원하는 답변을 찾지 못하셨나요?</p>
            <p className="text-[#6b5e4e] text-sm mt-1">전문 상담사가 직접 답변드립니다. 언제든지 편하게 문의해 주세요.</p>
          </div>
        </div>
        <div className="flex gap-3 shrink-0">
          <a href="/consultation" className="px-6 py-3 rounded-full text-sm font-bold whitespace-nowrap cursor-pointer transition-colors" style={{ backgroundColor: '#c9a84c', color: '#0d0d0d' }}>
            무료 상담 신청
          </a>
          <a href="/contact" className="px-6 py-3 rounded-full text-sm font-bold whitespace-nowrap cursor-pointer transition-colors" style={{ backgroundColor: 'transparent', color: '#c9a84c', border: '1px solid #c9a84c55' }}>
            연락처 보기
          </a>
        </div>
      </div>
    </section>
  );
}
